import React, { useEffect, useState } from 'react'
import axios from '~/data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import PagingBlock from '~/Common-Objects/Tables/DataTablePaging/DataTablePaging'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import DateTimeFunctions from '~/Classes/dateTimeFunctions'
import i18n from '~/i18n'


export default function ResendSends({ campaign }) {
    const [page, setPage] = useState(0)
    const [sends, setSends] = useState(null)
    const [total, setTotal] = useState(0)
    const [searchText, setSearchText] = useState('')
    const limit = 15

    const tableUpdater = (currentPage) => {
        setPage(currentPage)
    }

    const changeSearchText = event => {
        setSearchText(event.currentTarget.value)
    }

    const keyPress = event => {
        if (event.key === 'Enter') {
            search();
        }
    }

    const search = async () => {
        let query = `?offset=${page * limit}`
        if (searchText) query += `&search=${searchText}`
        const res = await axios.get('/campaign/' + campaign.id + '/stats/resent/detail' + query)
        setSends(res.data.rows)
        setTotal(res.data.count)
    }

    useEffect(() => {
        search()
    }, [campaign, page])

    if (!sends) return <LoadingIcons iconType="2" />

    const data = sends.map(row => ({
        emailAddress: {
            headerValue: i18n.t('emailAddress'),
            value: row.Subscriber.emailAddress,
        },
        sent: {
            headerValue: i18n.t('campaigns:resend.sends.sent'),
            value: DateTimeFunctions.formatDateTime(row.sendDate)
        }
    }))
    return (
        <Row>
            <Column xs={12} sm={6} md={4}>
                <TextInput className="txtInput" placeholder={i18n.t('searchForEmail')} onChange={changeSearchText} onKeyPress={keyPress} />
            </Column>
            <Column md={2} sm={12} xs={12}>
                <Button className="button button-md full-width min-shadow" onClick={search} style={{ minWidth: "150px" }}>{i18n.t('search')}</Button>
            </Column>
            <Column xs={12}>
                <Paper>
                    <DataTable1 tableData={data} dataUpdater={tableUpdater} width="100%" noResultsTxt={i18n.t('campaigns:resend.sends.none')} />
                </Paper>
                <div style={{ textAlign: "center" }}>
                    <PagingBlock totalRows={total} pageSize={limit} numberOfLinks="10" currentPage={page}
                        changePage={tableUpdater} text={i18n.t('page') + ":"} />
                </div>
            </Column>
        </Row>
    )
}